/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrgOrganizationsDesignRetrievePathOrgId, OrgOrganizationsDesignRetrieveStatus200 } from "../types/OrgOrganizationsDesignRetrieve.ts";

function getOrgOrganizationsDesignRetrieveUrl(org_id: OrgOrganizationsDesignRetrievePathOrgId) {
	const res = { method: "GET", url: `/api/org/organizations/${org_id}/design/` as const };

	return res;
}

/**
 * {@link /api/org/organizations/:org_id/design/}
 */
export async function orgOrganizationsDesignRetrieve(
	org_id: OrgOrganizationsDesignRetrievePathOrgId,
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<OrgOrganizationsDesignRetrieveStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "GET",
		url: getOrgOrganizationsDesignRetrieveUrl(org_id).url.toString(),
		...requestConfig,
	});

	return res.data;
}
